import { createAction } from "@reduxjs/toolkit";

export const apiCallInitiation = createAction("api/callInitiation");
export const apiCallSuccess = createAction("api/callSuccess");
export const apiCallFailure = createAction("api/callFailure");
